<template>
  <el-dropdown @command="handleSetLanguage">
    <el-button size="mini" class="language">
      <svg-icon icon-class="language" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        command="zh-TW"
        :disabled="language === 'zh-TW'"
        >
        繁體中文
      </el-dropdown-item>
      <el-dropdown-item
        command="zh-CN"
        :disabled="language === 'zh-CN'"
        >
        简体中文
      </el-dropdown-item>
      <el-dropdown-item
        command="en-US"
        :disabled="language === 'en-US'"
        >
        English
      </el-dropdown-item>
      <el-dropdown-item
        command="ja"
        :disabled="language === 'ja'">
        日本語
      </el-dropdown-item>
      <el-dropdown-item
        command="ms-MY"
        :disabled="language === 'ms-MY'">
        Bahasa Melayu
      </el-dropdown-item>
      <el-dropdown-item
        command="th-TH"
        :disabled="language === 'th-TH'">
        อักษรไทย
      </el-dropdown-item>
      <el-dropdown-item
        v-if="isShowKey"
        command="PhraseID"
        :disabled="language === 'PhraseID'">
        Phrase ID
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    language () {
      return this.$store.getters.language
    },
    isShowKey () {
      return process.env.NODE_ENV !== 'production'
    }
  },
  methods: {
    handleSetLanguage (lang) {
      this.$i18n.locale = lang
      if (lang === 'PhraseID') {
        this.$i18n.fallbackLocale = ''
        this.$i18n.silentTranslationWarn = true
      } else {
        this.$i18n.fallbackLocale = 'zh-TW'
        this.$i18n.silentTranslationWarn = false
        this.$moment.locale(lang)
      }
      this.$store.dispatch('setLanguage', lang)
      this.$store.dispatch('ResetLanguage', this)
      this.$store.dispatch('ResetCurrency')
      this.$ebus.$emit('renewList')
      this.$ebus.$emit('renewLang')
      this.$message({
        message: this.$t('i18n.switchLanguageSuccess'),
        type: 'success',
        duration: 2000
      })
      document.title = this.$t('login.title')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .language {
    font-size: 18px;
    padding: 5px 10px;
  }
</style>
